import { Loading } from '../../ontego-ui';
import Styled from './SpinnerStyles';

const Spinner = props => {
    const { style } = props

    return (
        <Styled.LoadingWrapper>
            <Loading style={{ ...style }} />
        </Styled.LoadingWrapper>
    )
}

export default Spinner